import React from 'react';

const signo = (props) => (
    (props.monto === undefined ? '' :
                            (props.monto < 0 ? <p style={{ color: 'red' }}>{`Registrando ${props.gasto}`}</p> : <p style={{ color: 'green' }}>{`Registrando ${props.ingreso}`}</p>)
                        )
);

export default signo;